import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

// Endpoint basado en la captura de Django REST Framework
export const baseURI = 'nominas/percepciones-puestos';

/**
 * GET Percepciones Puestos
 * @param {object} params - Usualmente { percepcion: id }
 * @returns {Promise<object[]>}
 */
export const getPercepcionesPuestos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Percepcion Puesto individual
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPercepcionPuesto = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Percepcion Puesto
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPercepcionPuesto = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Percepcion Puesto
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPercepcionPuesto = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Percepcion Puesto
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePercepcionPuesto = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
